import * as React from "react";

import {
    BulkyActionPicker,
    IActionCommand,
} from "../../../../common/component/action/action-select/bulky-action-picker";
import { observer } from "mobx-react";
import { Permission } from "../../../../context/permission";
import { operationContext } from "../../../../context/operation-context";
import { Parcel } from "../../../model/parcel";
import { ShipmentParcelActionType } from "../../../constants/constants";

interface IParcelShipmentHeaderProps {
    actionsList: Array<IActionCommand<Parcel, ShipmentParcelActionType>>;
    reloadParcelsList: () => Promise<void>;
}

@observer
export class ParcelShipmentHeader extends React.Component<IParcelShipmentHeaderProps, {}> {

    public render() {
        return <div className="list-actions-container">
            <div className="list-actions">
                <BulkyActionPicker withScanMode={true}
                                   propertyKey={operationContext.operationCodeOrEmpty}
                                   scanFieldType="text"
                                   inputLabel=""
                                   contentPrefix="parcelShipment.action"
                                   actions={this.props.actionsList}
                                   permission={Permission.FrontWrite} />
            </div>
        </div>;
    }
}
